// Auto-generated version info from package.json
// This file is updated automatically during build

export const APP_VERSION = '8.6.6';
export const CACHE_VERSION = `trackvas-v${APP_VERSION}`;
